import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import { SECURITY_STATUS, useSecurity } from '../../Contexts/SecurityContext';

const LicenseProtectedRoute = () => {
    const { status } = useSecurity();

    if (status === SECURITY_STATUS.RESOLVING) {
        return <LoadingScreen />;
    }
    if (status === SECURITY_STATUS.UNAUTHENTICATED) {
        return <Navigate to="/" replace />;
    }
    if (status !== SECURITY_STATUS.AUTHORIZED) {
        return <Navigate to="/access-denied" replace />;
    }

    return <Outlet />;
};

export default LicenseProtectedRoute;
